import { makeVar } from "@apollo/client";

export const isWebViewReact = makeVar(false);
